(function () {
    window.KocotAnimations = window.KocotAnimations || {};

    window.KocotAnimations.initLenis = function () {
        if (!window.Lenis || !document.body || window.lenis) {
            return;
        }

        window.lenis = new window.Lenis({
            content: document.body,
            autoRaf: true,
            anchors: true,
        });

        document.body.classList.add('lenis-ready');
    };
})();
